export default "__VITE_ASSET__CrAJyb3I__"